module.exports = __webpack_public_path__ + "img/tisco.0522606e.jpg";